import { render } from "./CanvasCtrl.vue?vue&type=template&id=66fd5520&bindings={\"preview\":\"options\",\"convert\":\"options\"}"
import script from "./CanvasCtrl.vue?vue&type=script&lang=js"
export * from "./CanvasCtrl.vue?vue&type=script&lang=js"

import "./CanvasCtrl.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script